const focusedSpecialityData = {
  Cardiology: {
    image: "/images/Cardiology.webp",
    points: [
      "Angioplasty",
      "Bypass Surgery (CABG)",
      "Pacemaker Implantation",
      "Transcatheter Valve Replacement",
      "Heart Transplant",
      "EPS RFA Procedure",
    ],
  },
  Cosmetics: {
    image: "/images/2.webp",
    points: [
      "Gender Affirmation Surgery",
      "Liposuction",
      "Rhinoplasty",
      "Nose Reshaping",
      "Breast Reduction",
      "Hair Transplantation",
    ],
  },
  Gynaecology: {
    image: "/images/Gynaecology.webp",
    points: [
      "Total Laparoscopic Hysterectomy",
      "Dilation & Curettage",
      "Laparoscopic Oophorectomy",
      "Uterine Fibroid Removal",
      "Laparoscopic Cystectomy",
      "Hysteroscopy",
    ],
  },
  Hematology: {
    image: "/images/Hematology.webp",
    points: [
      "Bone Marrow Transplant",
      "Blood Cancer Treatment",
      "CAR T Cell Therapy",
      "Hemophilia Treatment",
      "Multiple Myeloma Treatment",
      "Anemia Management",
    ],
  },
  Fertility: {
    image: "/images/Fertility.webp",
    points: [
      "IVF (In Vitro Fertilization)",
      "Intracytoplasmic Sperm Injection",
      "Egg & Sperm Freezing",
      "Male Infertility Treatment",
      "Surrogacy Program",
    ],
  },
  Oncology: {
    image: "/images/Oncology.webp",
    points: [
      "Cervical Cancer Treatment",
      "Prostate Cancer Treatment",
      "Liver Cancer Treatment",
      "Thyroid Cancer Treatment",
      "Lung Cancer Treatment",
    ],
  },
  Neurosurgery: {
    image: "/images/Neurosurgery.webp",
    points: [
      "Brain Tumor Surgery",
      "Brain Aneurysm Repair",
      "Deep Brain Stimulation Surgery",
      "Pituitary Tumor Surgery",
      "CyberKnife",
      "Craniotomy",
    ],
  },
  Orthopedics: {
    image: "/images/Orthopaedics.webp",
    points: [
      "Joint Replacement Surgery",
      "Arthroscopy",
      "Spinal Surgery",
      "Fracture Repair",
      "Sports Medicine",
    ],
  },
  Liver: {
    image: "/images/Liver.webp",
    points: [
      "Liver Transplant",
      "Pediatric Liver Transplant",
      "Liver Resection",
    ],
  },
  Kidney: {
    image: "/images/Kidney.webp",
    points: [
      "Kidney Transplant",
      "Kidney Stone Removal Surgery",
      "Chronic Kidney Disease Treatment",
    ],
  },
  "Weight Loss": {
    image: "/images/Weight.webp",
    points: ["Bariatric Combination Agents", "GLP-1 Drugs (Bariatric Medication) test"],
  },
};

export default focusedSpecialityData;